<template>
  <div class="root">
    <div class="root__image">
      <img src="/assets/placeholder.jpg" alt="skeleton-image" width="179" height="179" loading="eager" fetchpriority="high">
    </div>
    <span class="skeleton line line_label" />
    <div class="contents contents_text">
      <span class="skeleton line" />
      <span class="skeleton line line_w-50" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderSliderProductSkeleton'
}
</script>

<style scoped lang="scss">
.root {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 12px;

  &__image {
    max-width: -webkit-fill-available;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
}

.contents {
  display: contents;

  &_text {
    .line:not(:last-of-type) {
      margin-bottom: -4px;
    }
  }
}
.skeleton {
  animation: skeleton-loading 1s linear infinite alternate;
  object-fit: cover;
  flex-shrink: 0;
}

.line {
  height: 12px;
  width: -webkit-fill-available;

  &_w-50 {
    width: 50%;
  }

  &_label {
    height: 14px;
  }
}

@keyframes skeleton-loading {
  0% {
    background-color: hsl(60, 6%, 94%);
  }
  100% {
    background-color: hsl(0, 0%, 85%);
  }
}
</style>
